import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-refuelInput-control-label-view, [app-refuelInput-control-label-view]',
  templateUrl: './refuelInput-control-label-view.component.html',
  styleUrls: ['./refuelInput-control-label-view.component.scss']
})
export class RefuelInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
